import { watchChangePassword } from "./changePassword";
import { watchChangeProfile } from "./changeProfile";
import { watchChangeMFA } from "./changeProfile";
import * as acceptInvite from "./acceptInvite/";
import * as resetPassword from "./resetPassword/";
import * as appIdentityCheck from "./appIdentityCheck/";

import { all } from "redux-saga/effects";

export function* rootSaga() {
  yield all([
    watchChangePassword(),
    watchChangeProfile(),
    watchChangeMFA(),
    acceptInvite.rootSaga(),
    resetPassword.rootSaga(),
    appIdentityCheck.rootSaga(),
  ]);
}
